/* eslint-disable react/jsx-no-target-blank */
import { Link } from 'react-router-dom';
import { FiUser} from "react-icons/fi";
import { ImFacebook, ImLinkedin2 } from "react-icons/im";
import { FaInstagram,FaWhatsapp } from "react-icons/fa";
import "./MovileMenu.scss";

export const MovilMenu = ({closeMenu, isOpen}) => {
    return (
        <>
            {isOpen && (
                <div className='movil'>
                    <section className='container-movil'>
                        <nav className='movil-menu'>
                            <Link className='button-navbar' to="/" onClick={closeMenu}>Inicio</Link>
                            <Link className='button-navbar' to="/nosotros" onClick={closeMenu}>Nosotros</Link>
                            <Link className='button-navbar' to="/productos" onClick={closeMenu}>Productos</Link>
                            <Link className='button-navbar' to="/plataforma" onClick={closeMenu}>Plataforma</Link>
                            <Link className='button-navbar' to="/blog" onClick={closeMenu}>Blog</Link>
                            <Link  className='button-color' to="/login" >Login <FiUser/></Link>
                        </nav>
                        <nav className='redes-menu'>
                            <a href='https://www.linkedin.com/company/shofi/' className='redes' target="_blank"><ImLinkedin2 /></a>
                            <a href='https://www.facebook.com/shoficolombia' className='redes' target="_blank"><ImFacebook /></a>
                            <a href='https://www.instagram.com/shofi_colombia/' className='redes' target="_blank"><FaInstagram /></a>
                            <a href='https://api.whatsapp.com/send/?phone=573058080419&text=%C2%A1Hola%21+Me+gustar%C3%ADa+obtener+m%C3%A1s+informaci%C3%B3n.&type=phone_number&app_absent=0' className='redes' target="_blank"><FaWhatsapp /></a>
                        </nav>
                    </section>
                </div>
            )}
        </>
    );
}